module.exports = __webpack_public_path__ + "static/media/rentRates2BedRoom-allDwelling-02.052290d0.png";